import React, { useContext, useEffect, useState } from 'react';
import back from "../dist/webImages/back.svg";
import { Field, Form, Formik } from 'formik';
import FormControl from '../components/form/FormControl';
import SubmitButton from '../components/SubmitButton';
import CKEditors from '../components/form/CKEditors';
import { Link, useNavigate, useParams } from 'react-router-dom';
import SkeletonCreateEdit from './SkeletonCreateEdit';
import { MainLanguageContext } from '../context/MainLanguageContext';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import plus from "../dist/webImages/plus.svg"
import useGet from '../customHooks/useGet';
import usePost2 from '../customHooks/usePost2';
import { MainUserDataContext } from '../context/MainUserDataContext';
import MediaLibraryModal from '../components/MediaLibraryModal';
import { FiImage, FiTrash2 } from 'react-icons/fi';

const EditBlogs = ({ permission }) => {
  const { slug } = useParams();
  const { userdata } = useContext(MainUserDataContext);
  const navigate = useNavigate();
  const [resget, apiMethodGet] = useGet()
  const { mainLanguage } = useContext(MainLanguageContext);
  const [datas, setDatas] = useState()

  useEffect(() => {
    apiMethodGet(`blogs/edit/${slug}/${mainLanguage}`)
  }, [slug, mainLanguage]);


  useEffect(() => {
    if (resget.data) {
      const aaa = resget.data?.data;

      // Function to replace specific special characters
      function replaceSpecialCharacters(str) {
        if (!str) return ''; // Handle undefined or null input
        return str
          .replace(/&amp;/g, '&') // Replace encoded ampersand
          .replace(/&lt;/g, '<') // Replace encoded less-than
          .replace(/&gt;/g, '>') // Replace encoded greater-than
          .replace(/&quot;/g, '"') // Replace encoded double quotes
          .replace(/&#39;/g, "'"); // Replace encoded single quotes
      }

      // Replace special characters in blog_paragraph
      const cleanedParagraph = replaceSpecialCharacters(aaa.blog_paragraph);

      // Update state with cleaned data
      setDatas({
        ...aaa,
        blog_paragraph: cleanedParagraph,
        sec_faqs: Array.isArray(aaa?.sec_faqs) && aaa.sec_faqs.length > 0 ? aaa.sec_faqs : [{
          question: "",
          answer: "",
        }],
        sec_faqs_heading: aaa?.sec_faqs_heading ?? "",
      });
    }
  }, [resget.data])

  const [mediaOpen, setMediaOpen] = useState(false);


  const handleCkChange = (e, type) => {
    setDatas(d => ({ ...d, [type]: e }));
  };

  const handleSectionAdd = (sectionKey, fields) => {
    const newEntry = Object.fromEntries(fields.map((field) => [field, ""]));

    setDatas((prevState) => ({
      ...prevState,
      [sectionKey]: [...(prevState[sectionKey] || []), newEntry],
    }));
  };

  const handleDelete = (section, index) => {
    setDatas(prevService => ({
      ...prevService,
      [section]: (Array.isArray(prevService[section]) ? prevService[section] : []).filter((item, index2) => index !== index2)
    }));
  }

  const handleCkChange2 = (text, section, index, paragraph) => {
    setDatas(prevService => ({
      ...prevService,
      [section]: prevService[section].map((item, index2) =>
        index === index2 ? { ...item, [paragraph]: text } : item
      )
    }));
  }
  const [res, apiMethod] = usePost2();
  const requireFeild = ["meta_title", "meta_description", "blog_title", "blog_slug ", "blog_schedule"];
  const handleSubmit = async (values) => {
    let requireFeildSwal = {
      meta_title: "Meta title",
      meta_description: "Meta Description",
      blog_title: "Title",
      blog_slug: "slug",
      blog_schedule: "Schedule",
    };
    let checkerRequried = [];
    for (const item in values) {
      if (requireFeild.includes(item) && !values[item]) {
        checkerRequried.push(requireFeildSwal[item]);
      }
    }
    if (checkerRequried.length > 0) {
      swal({
        title: "Required Fields are empty! Please fill and try again",
        text: checkerRequried.join(","),
        icon: "error",
        dangerMode: true,
      });
      return;
    }

    const updateData = {
      "blog_image": datas?.blog_value ?? "",
      "blog_slug": values["blog_slug"],
      "blog_status": values["blog_status"].length > 0 ? 1 : 0,
      "blog_schedule": `${values["blog_schedule"].replace("T", " ")}` ?? "",
      "table_of_content": values["table_of_content"].length > 0 ? 1 : 0,
      "translation": {
        "meta_title": values["meta_title"],
        "custom_schema": values["custom_schema"] ?? "",
        "meta_description": values["meta_description"],
        "blog_title": values["blog_title"],
        "blog_image_alt": values["blog_image_alt"],
        "sec_faqs_heading": values["sec_faqs_heading"] ?? "",
        "blog_paragraph": datas?.blog_paragraph,
        "sec_faqs": datas?.sec_faqs ?? [],
      }
    }
    apiMethod(`blogs/update/${datas?.id}/${mainLanguage}`, updateData)
  };

  useEffect(() => {
    if (res.data) {
      const { status, message } = res?.data
      if (status === "false") {
        toast.error(message);
      }
      else {
        navigate("/blogs")
        toast.success(message);
      }
    }
  }, [res.data])
  if (resget.isLoading || !datas) return <SkeletonCreateEdit heading={"Edit Blogs"} />;
  const { blog_paragraph, sec_faqs } = datas;
  let initialValues = {
    meta_title: resget?.data?.data.meta_title,
    meta_title: resget?.data?.data.meta_title,
    meta_description: resget?.data?.data.meta_description,
    custom_schema: resget?.data?.data.custom_schema ?? "",
    blog_slug: resget?.data?.data.blog_slug,
    blog_title: resget?.data?.data.blog_title,
    blog_image_alt: resget?.data?.data.blog_image_alt ?? "",
    sec_faqs_heading: resget?.data?.data.sec_faqs_heading ?? "",
    blog_status: resget?.data?.data.blog_status && [`${String(resget?.data?.data.blog_status)}`],
    table_of_content: resget?.data?.data.table_of_content && [`${String(resget?.data?.data.table_of_content)}`],
    blog_schedule: resget?.data?.data.blog_schedule.replace(" ", "T"),
  };
  const check = (module, action) => permission?.[module]?.includes(action);
  return (
    <div className='newscreate pr-10 max-lg:pr-6'>
      <Link to={"/blogs"} className="back flex items-center mb-6 gap-2">
        <img src={back} className='w-[2rem]' alt="" />
        <span className='text-[1.4rem] font-MluvkaBold'>Edit Blogs</span>
      </Link>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        <Form name="myForm">
          <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3 max-lg:p-3'>
            <div className="grid grid-cols-2 gap-2">

              {
                mainLanguage === "en" ?
                  <FormControl disable name="blog_slug" label={"Slug"} placeholder="Enter Slug" className="outline-none  w-full h-[3rem] px-5 rounded-xl border border-[red]" control="input2" />
                  :
                  <div className='inputBox w-full mt-3'>
                    <label htmlFor="Schedule" className="mb-1 block text-[#7D8CA7] text-[.8rem]">Slug</label>
                    <p className="outline-none bg-[#e7e7e7] w-full h-[3rem] px-5 rounded-xl py-3">{datas?.blog_slug}</p>
                  </div>

              }
              <FormControl name="meta_title" label={"Meta Title"} placeholder="Enter Meta Title" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            </div>
            <div className="grid  gap-2">
              <FormControl name="meta_description" label={"Meta Description"} placeholder="Enter Meta Description" className="outline-none w-full h-[10rem] px-5 py-3 rounded-xl resize-none" control="textarea2" />
            </div>
          </div>
          <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3'>
            <div className="h4 text-[#7D8CA7] text-[1.1rem] ">Blog</div>
            <div className='mt-4'>
              <label className="mb-2 mt-3 block text-[#243B5A] text-[.8rem]">Image</label>
              <div className="rounded-[14px] border border-[#DCE5F1] bg-[#F8FAFC] p-3">
                <div className="flex gap-2">
                  <div className="flex h-9 min-w-0 flex-1 items-center gap-2 rounded-full border border-[#D8D8D8] bg-white px-3 text-xs text-[#555]">
                    <FiImage className="shrink-0 text-[#8A9AB5]" />
                    <span className="truncate">{datas?.blog_value || datas?.blog_image || "Image URL"}</span>
                  </div>
                  <button type="button" onClick={() => setMediaOpen(true)} className="flex h-9 items-center gap-2 rounded-full border border-[#D8D8D8] bg-white px-4 text-xs text-[#333] hover:border-[#B78A42]"><FiImage size={14} /> Gallery</button>
                  {datas?.blog_image && <button type="button" onClick={() => setDatas((prev) => ({ ...prev, blog_image: "", blog_value: "" }))} className="flex h-9 items-center gap-2 rounded-full border border-[#E34D4D] px-4 text-xs text-[#D93636] hover:bg-[#FFF3F3]"><FiTrash2 size={14} /> Clear</button>}
                </div>
                <div className="mt-3 min-h-[112px] rounded-[12px] border border-[#DCE5F1] bg-white p-3">
                  {datas?.blog_image ? <img src={datas.blog_image} alt="Blog" className="h-[88px] w-[88px] rounded-[12px] object-cover" /> : <div className="grid h-[88px] place-items-center text-xs text-[#98A6BA]">No image selected</div>}
                </div>
              </div>
            </div>
            <FormControl name="blog_title" label={"Heading {h1}"} placeholder="Enter Heading" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            <br />
            <div className="mb-1 block text-[#7D8CA7] text-[.8rem]">Main Paragraph</div>
            <CKEditors label={"Main Paragraph"} folder_name={"blogs-images"} page_type={"blogs"} data={blog_paragraph} update={(text) => handleCkChange(text, "blog_paragraph")} />
            <div className="mb-4 mt-3">
              <label className="mb-1 block text-[#7D8CA7] text-[.8rem]">
                Custom Schema JSON-LD
              </label>
              <FormControl
                name="custom_schema"
                rows={15}
                control="textarea"
                className="w-full outline-0 rounded-lg border p-3 font-mono text-sm"
                placeholder={`{"@context": "https://schema.org","@type": "Article"}`}
              />
            </div>

            <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3'>
              <div className='flex justify-between'>
                <div className="h4 text-[#7D8CA7] text-[1.1rem] ">Faqs</div>
                <Link className='bg-[#d9dcf8] py-3 px-6 rounded-full flex items-center gap-2 cursor-pointer' onClick={() => handleSectionAdd("sec_faqs", ["question", "answer"])} >
                  <img src={plus} alt="plus" style={{ filter: "brightness(100)" }} />
                  <span className='font-MluvkaBold text-white capitalize'>Add new</span>
                </Link>
              </div>
              <FormControl name="sec_faqs_heading" label={"Faqs Title"} placeholder="Enter Title" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />

              <div className="section4Main grid grid-cols-2 gap-3 mt-4 max-lg:grid-cols-1">
                {
                  Array.isArray(sec_faqs) && sec_faqs.map((item, index) => {
                    const { question, answer } = item
                    return (
                      <div className="section3MainBox bg-[#DEE5F2] p-4 rounded-lg relative" key={index}>
                        <div className='mb-3'>
                          <label htmlFor="" className='mb-2 text-[#7D8CA7] text-[.8rem] items-center flex justify-between'>
                            <span>Question</span>
                            <div className='closeButton cursor-pointer  bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem]  grid place-items-center rounded-[.7rem] z-10' onClick={() => handleDelete("sec_faqs", index)}>
                              <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </div>
                          </label>
                          <div className='smallValue'>
                            <CKEditors label={"question"} data={question} update={(text) => handleCkChange2(text, "sec_faqs", index, "question")} />
                          </div>
                        </div>
                        <div className=''>
                          <label htmlFor="" className='mb-1 text-[#7D8CA7] text-[.8rem] block'><span>Answer</span> </label>
                          <CKEditors label={"Answer"} data={answer} update={(text) => handleCkChange2(text, "sec_faqs", index, "answer")} />
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>

            <FormControl name="blog_image_alt" label={"Heading Image Alt"} placeholder="Enter Blog Image Alt" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />

            <br />
            {
              mainLanguage === "en" ?
                <FormControl name="blog_schedule" label={"Schedule"} type={'datetime-local'} placeholder="Enter Schedule" className="outline-none w-full h-[3rem] px-5 rounded-xl"  control={"input"}  />
                :
                <div className='inputBox w-full mt-3'>
                  <label htmlFor="Schedule" className="mb-1 block text-[#7D8CA7] text-[.8rem]">Schedule</label>
                  <p className="outline-none bg-[#e7e7e7] w-full h-[3rem] px-5 rounded-xl py-3">{datas?.blog_schedule?.replace(" ", "T") ?? ""}</p>
                </div>

            }

            <div className="overflow-hidden relative pt-7 px-4">
              <label className="inline-flex items-center cursor-pointer">
                <Field value="1" type="checkbox" name="blog_status" className="sr-only peer" />
                <div className="relative bg-[#1c1c1c] w-11 h-6 bg-gray-200 peer-focus:outline-none  rounded-full peer bg-gray-200 peer-checked:after:translate-x-full   after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#401a89]"></div>
                <span className="ms-3 text-sm font-medium text-gray-900">Blog Status</span>
              </label>
            </div>
            <div className="overflow-hidden relative pt-7 px-4">
              <label className="inline-flex items-center cursor-pointer">
                <Field value="1" type="checkbox" name="table_of_content" className="sr-only peer" />
                <div className="relative bg-[#1c1c1c] w-11 h-6 bg-gray-200 peer-focus:outline-none  rounded-full peer bg-gray-200 peer-checked:after:translate-x-full   after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#401a89]"></div>
                <span className="ms-3 text-sm font-medium text-gray-900">Table of Content</span>
              </label>
            </div>


          </div>
          {check("Blogs", "Blogs Edit") && <SubmitButton
            props={{
              class: "btn bg-secondary text-white px-12 ml-auto uppercase mb-3   py-3 rounded-full w-100 block mt-5 submit hover:bg-primary transition-all duration-300",
              text: "Submit",
            }}
            buttonLoading={res.isLoading}
          />}
          <MediaLibraryModal
            open={mediaOpen}
            onClose={() => setMediaOpen(false)}
            initialFolder="blogs_images"
            onSelect={(image) => {
              setDatas((prevState) => ({
                ...prevState,
                blog_image: image?.image_full_path || image?.image_path || "",
                blog_value: image?.image_path || "",
              }));
              setMediaOpen(false);
            }}
          />
        </Form>
      </Formik>
    </div>
  )
}

export default EditBlogs
